import df from "./dateFormater";
import request from "./request";
import { getSession } from "./sessionHandler";

const print = (packageDetail, id) => {
  const methodNameLines = packageDetail?.methodName?.length > 15 ? 2 : 1; 
  const operatorHeight = methodNameLines === 2 ? 130 : 100; 

// Separar cycleNumber y sterilizerName
const cycleNumber = packageDetail?.chargeRelated?.cycleNumber || "";
const sterilizerName = packageDetail?.chargeRelated?.sterilizerName || "";

// Dividir sterilizerName en dos líneas si es demasiado largo
const maxCharsPerLine = 20;
const sterilizerFirstLine = sterilizerName.slice(0, maxCharsPerLine);
const sterilizerSecondLine = sterilizerName.length > maxCharsPerLine ? sterilizerName.slice(maxCharsPerLine) : null;

function truncateText(text, maxLength) {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;
}
const maxObservationsLength = 40; 
const truncatedObservations = truncateText(packageDetail?.observations, maxObservationsLength);

const content = `
^XA
^CI28 ; Habilita UTF-8 para acentos
^JUS
^XZ
^XA
^FX Top section with logo, name and address.
^CF0,60
^CF0,30
^FO100,40^FD${packageDetail?.packageNumber} ${packageDetail?.description}^FS

^FO100,70
^FB180,${methodNameLines},0,L,0
^FD${packageDetail?.methodName}^FS

^FO300,70^FD${df(packageDetail?.creationDate, "dateTime")}^FS

^FO100,${operatorHeight}^FD ${packageDetail?.operator}^FS

${cycleNumber || sterilizerName ? `
^FO300,${operatorHeight}^FD${cycleNumber} ${sterilizerFirstLine}^FS
${sterilizerSecondLine ? `^FO300,${operatorHeight + 20}^FD${sterilizerSecondLine}^FS` : ""}
` : ""}

^FO100,${operatorHeight + 40 + (sterilizerSecondLine ? 20 : 0)}^GB570,3,3^FS ; Línea divisora

^FX Third section with bar code.
^BY2,2,70
^FO146,${operatorHeight + 55 + (sterilizerSecondLine ? 20 : 0)}^BC^FDP${id}${packageDetail?.packageNumber}^FS
^FO100,${operatorHeight + 150 + (sterilizerSecondLine ? 20 : 0)}^FD${truncatedObservations}^FS
^XZ
`;

  // Crear un documento HTML temporal
  var ventanaImpresion = window.open("", "", "width=600,height=600");
  ventanaImpresion.document.open();

  // Agregar el content del archivo TXT al documento HTML
  ventanaImpresion.document.write("<pre>" + content + "</pre>");

  ventanaImpresion.document.close();

  // Llamar a la función de impresión
  ventanaImpresion.print();

  // Cerrar la ventana temporal después de la impresión
  ventanaImpresion.close();
};

export default function printTicket(packageDetail) {
  const infouser = getSession();
  let user;
  


  if (infouser.SectorId)
    request()
      .get(`/api/Sector/${infouser.SectorId}`)
      .then((res) => {
        infouser.SectorName = res.data.name;
        print(packageDetail, infouser.IdDistributorCompany.replace(/-/g, ""));
      });
  else return;
}
